'use client'
import React, { useState } from 'react'
import TeamPickImage from '../teamPickImage'
import CustomLink from '../../customLink'
import MyImage from '../../myImage'
import facebook from '@/assets/images/advertisement/icons/facebook.svg'
import instagram from '@/assets/images/advertisement/icons/instagram.svg'
import youtube from '@/assets/images/advertisement/icons/youtube.svg'
import x from '@/assets/images/advertisement/icons/x.svg'
import { WarningIcon } from '@/shared/Icons'

function Leagues({ data, title = true, bg }: any) {
  const tabsName: any = {
    ml: 'Mega League',
    gl: 'Grand League',
    hth: 'Head To Head',
    cs: 'CB Special'
  }

  const tabs: any = []
  data?.aLeague?.map((l: any) => {
    tabs.push({ title: tabsName[l?.eLeague], eType: l?.eLeague })
  })

  const [activeTab, setActiveTab] = useState<any>(tabs?.[0] || '')

  return (
    <>
      <div className='mb-4 mt-6 md:mt-8 md:mb-6 flex flex-col md:flex-row gap-3 md:items-center justify-between'>
        {title && (
          <h4 className='text-sm md:text-lg text-textOffWhite font-bold m-0'>
            Top Team Pick
          </h4>
        )}
        <div className='flex gap-3'>
          {tabs?.map((t: any, i: number) => (
            <span
              onClick={() => setActiveTab(t)}
              className={`rounded-lg md:px-6 py-2 px-2 cursor-pointer text-xs md:text-sm border border-tabBorder font-bold hover:border-buttonBg hover:bg-transparent dark:hover:text-white transition-all hover:text-buttonBg ${
                t?.title === activeTab?.title
                  ? '!bg-buttonBg dark:!text-textOffWhite !text-white'
                  : 'bg-transparent text-textDselected'
              }`}
              key={i}
            >
              {t?.title}
            </span>
          ))}
        </div>
      </div>
      {data?.aLeague?.map((l: any, i: number) => {
        if (l?.eLeague === activeTab?.eType) {
          return <TeamPickImage key={i} data={l?.aTeam[0]} bg={bg} />
        }
      })}

      <div className='grid grid-cols-12 gap-4 mt-5 bg-headersActive rounded-[16px] items-center'>
        <div className='col-span-6 md:col-span-8 w-full px-5 py-[16px]'>
          <p className='text-textOffWhite w-full hidden sm:block font-semibold'>
            Get every cricket update! Follow Us:
          </p>
          <p className='col-span-6 text-textOffWhite w-full block sm:hidden font-bold'>
            Follow Us:
          </p>
        </div>

        <div className='flex justify-end gap-1 col-span-6 md:col-span-4 px-5'>
          <CustomLink href='https://www.facebook.com/people/Cricket-bazaar/61558466016828'>
            <MyImage src={facebook} alt='Facebook' className='w-10 h-10' />
          </CustomLink>
          <CustomLink href='https://www.instagram.com/cricket.bazaar/'>
            <MyImage src={instagram} alt='Instagram' className='w-10 h-10' />
          </CustomLink>
          <CustomLink href='https://x.com/tweetsbycb'>
            <MyImage src={x} alt='Twitter' className='w-10 h-10' />
          </CustomLink>
          <CustomLink href='https://www.youtube.com/channel/UCPqYRjS23n4qc3Z0Bi6sVTQ'>
            <MyImage src={youtube} alt='YouTube' className='w-10 h-10' />
          </CustomLink>
        </div>
      </div>

      <div className='w-full rounded-[16px] p-[12px] bg-headersActive flex flex-col gap-2 mt-5'>
        <div className='flex flex-nowrap items-center gap-1 '>
          <WarningIcon />
          <p className='text-[17px] sm:text-[20px] font-bold pl-1'>
            DISCLAIMER
          </p>
        </div>
        <p className='text-xs md:text-base font-normal text-t-origin'>
          This team is based on the understanding, analysis, and instinct of the
          author. While selecting your team, consider the points mentioned and
          make your own decision.
        </p>
      </div>
    </>
  )
}

export default Leagues
